export default "__VITE_ASSET__2odYx0at__"